import { RenderingDetailsMeta } from "@swiggy-private/cart-types";
import { format, isEmpty } from "@swiggy-private/core-ui";
import {
    DELIVERY_TEXT_COUNTER_SEPERATORS,
    SCREEN_READER_TEXT_FOR_DELIVERY_COUNTER,
    SCREEN_READER_TEXT_FOR_DELIVERY_COUNTER_MWEB,
    SUPER_V3_RENDERING_TYPES,
} from "@super-ui/constants/SwiggyOne";
import {
    DeliveryTagInfoUIData,
    DeliveryTagInfoUIDataMweb,
    DeliveryTagInfoVisibilityLevel,
    NudgeType,
    ProgramSubTypes,
    ProgramTypes,
} from "@super-ui/interfaces/SwiggyOne";
import { getDeliveryTagInfoColors } from "@super-ui/components/swiggy-one-widget-dls-wrapper";

export const isSuperV3Nudge = (key = ""): boolean => key.toUpperCase() === SUPER_V3_RENDERING_TYPES.NUDGE;
export const isSuperV3Benefits = (key = ""): boolean => key.toUpperCase() === SUPER_V3_RENDERING_TYPES.BENEFITS;

export const isTrialPlan = (meta: RenderingDetailsMeta = {}): boolean => meta.nudge_type === NudgeType.TRIAL;

export const isOneTap = (meta: RenderingDetailsMeta = {}): boolean => meta.nudge_type === NudgeType.ONE_TAP;

export const isRegularNudge = (meta: RenderingDetailsMeta = {}): boolean => meta.nudge_type === NudgeType.REGULAR;

export const shouldShowTitleShimmer = (key = "", isTrialPlan: boolean, meta: RenderingDetailsMeta = {}): boolean =>
    isSuperV3Nudge(key) && !isTrialPlan && !isOneTap(meta);

export const getOfferBadgeText = (meta: RenderingDetailsMeta = {}): string | undefined => meta.badge_info?.text;

export const isOneLiteProgramAndType = (meta: RenderingDetailsMeta = {}): boolean => {
    return (
        meta?.active_plan_details?.program === ProgramTypes.ONE &&
        meta?.active_plan_details?.type === ProgramSubTypes.LITE
    );
};

export const colorPickerBasedOnVisibilityLevel = (visibilityLevel: string) => {
    return {
        isHigh: visibilityLevel === DeliveryTagInfoVisibilityLevel.HIGH,
        isLow: visibilityLevel === DeliveryTagInfoVisibilityLevel.LOW,
        isMedium: visibilityLevel === DeliveryTagInfoVisibilityLevel.MEDIUM,
    };
};

export const getDeliveryTagInfoData = (
    meta: RenderingDetailsMeta = {},
    isUX3WidgetForMweb = false,
): DeliveryTagInfoUIData | DeliveryTagInfoUIDataMweb | undefined => {
    const deliveryInfo = meta?.delivery_tag_info;
    if (!isEmpty(deliveryInfo)) {
        // there is an older checkout-web widget as well which used [[ ]] for delivery count
        // cleanup is pending in checkout-web we have moved to DLS widget, so we need to handle both
        // also, super-ui is being used in mweb older UI as well, so we need to handle that as well
        if (
            !isUX3WidgetForMweb &&
            deliveryInfo?.text.includes(DELIVERY_TEXT_COUNTER_SEPERATORS.START) &&
            deliveryInfo?.text.includes(DELIVERY_TEXT_COUNTER_SEPERATORS.END)
        ) {
            let [deliveryCount, deliveryCountText] = deliveryInfo.text.split(DELIVERY_TEXT_COUNTER_SEPERATORS.END);
            deliveryCount = deliveryCount.split(DELIVERY_TEXT_COUNTER_SEPERATORS.START)[1].trim();
            deliveryCountText = deliveryCountText.trim();
            const colorType = colorPickerBasedOnVisibilityLevel(deliveryInfo?.visibility_level);
            if (!isEmpty(colorType)) {
                return {
                    count: deliveryCount,
                    countText: deliveryCountText,
                    countSubText: deliveryInfo.sub_text,
                    colorType: colorType,
                } as DeliveryTagInfoUIData;
            }
        } else if (isUX3WidgetForMweb) {
            const cleanupText = deliveryInfo?.text
                ?.replace(DELIVERY_TEXT_COUNTER_SEPERATORS.START, "")
                .replace(DELIVERY_TEXT_COUNTER_SEPERATORS.END, "");
            return {
                pillText: cleanupText,
                subText: deliveryInfo?.sub_text?.toLowerCase() || "",
                ...getDeliveryTagInfoColors(deliveryInfo),
            } as DeliveryTagInfoUIDataMweb;
        }
    }
};

export const a11yTextBuilderForDeliveryTabMweb = (subText: string, text: string): string => {
    if (isEmpty(subText) || isEmpty(text)) return "";
    return format(SCREEN_READER_TEXT_FOR_DELIVERY_COUNTER_MWEB, subText, text);
};

export const getScreenReaderTextForDeliveryInfo = (count: string, countSubText: string, countText: string) => {
    // You have 2 free delivery left
    return format(SCREEN_READER_TEXT_FOR_DELIVERY_COUNTER, count, countSubText, countText);
};
